import { TranslationKeys } from '../index';

export const fr: TranslationKeys = {
  betBuilder: {
    title: 'Constructeur de Paris',
    noBetsSelected: 'Le Constructeur de Paris est vide',
    addSelections: 'Ajouter des sélections',
    totalOdds: 'Cotes Totales',
    totalSelections: 'Total des Sélections',
    clearAll: 'Tout Effacer',
    removeBet: 'Supprimer le pari',
    addBet: 'Ajouter un pari',
    event: 'Événement',
    market: 'Marché',
    selection: 'Sélection',
    odds: 'Cotes',
    confirmClear: 'Effacer Tous les Paris',
    confirmClearMessage: 'Êtes-vous sûr de vouloir supprimer tous les paris ? Cette action ne peut pas être annulée.',
    cancel: 'Annuler',
    confirm: 'Tout Effacer',
    closed: 'Fermé',
    suspend: 'Suspendre',
    eventClosed: 'Événement Fermé',
    eventSuspended: 'Événement Suspendu',
    buildABet: 'Construire un pari'
  },
  betStatus: {
    won: 'Gagné',
    pending: 'En Attente',
    refund: 'Remboursement',
    lost: 'Perdu',
    halfwon: 'Demi-Gagné',
    halflost: 'Demi-Perdu',
    cashout: 'Retrait',
    unknown: 'Inconnu'
  },
  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    retry: 'Réessayer',
    close: 'Fermer',
    save: 'Sauvegarder',
    edit: 'Modifier',
    delete: 'Supprimer',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    search: 'Rechercher',
    filter: 'Filtrer',
    sort: 'Trier',
    settings: 'Paramètres'
  },
  errors: {
    generic: 'Quelque chose s\'est mal passé. Veuillez réessayer.',
    network: 'Erreur réseau. Veuillez vérifier votre connexion.',
    notFound: 'La ressource demandée n\'a pas été trouvée.',
    unauthorized: 'Vous n\'êtes pas autorisé à effectuer cette action.',
    validation: 'Veuillez vérifier votre saisie et réessayer.'
  }
};